import React from 'react';
import { MessageSquare } from 'lucide-react';
import { Modal } from '../ui/Modal';
import { Button } from '../ui/Button';
import { Textarea } from '../ui/Input';
import { Badge } from '../ui/Badge';
import { Spinner } from '../ui/Spinner';

/**
 * Reviews modal — lists existing comments and lets logged-in users add a new one.
 */
export function BusinessReviewsModal({
    isOpen,
    onClose,
    reviews,
    loading,
    isGuest,
    newComment,
    onChangeComment,
    onSubmitComment,
    posting,
}) {
    return (
        <Modal isOpen={isOpen} onClose={onClose} title="תגובות" size="md">
            <div className="space-y-4">
                <div className="flex items-center justify-between">
                    <p className="text-xs text-ink-muted">להלן תגובות שכבר נוספו על-ידי משתמשים</p>
                    <Badge variant="brand" tone="soft" size="sm">
                        {reviews.length}
                    </Badge>
                </div>

                {loading ? (
                    <div className="text-center py-6">
                        <Spinner size="lg" />
                    </div>
                ) : reviews.length === 0 ? (
                    <div className="bg-surface-muted border border-line-subtle rounded-lg p-4 text-center">
                        <p className="text-ink-muted text-sm">אין עדיין תגובות. היו הראשונים להגיב!</p>
                    </div>
                ) : (
                    <div className="space-y-3 max-h-96 overflow-y-auto pe-1 -me-1">
                        {reviews.map((rev, idx) => (
                            <div key={idx} className="surface-card p-4 text-right">
                                <div className="flex items-center justify-between mb-2">
                                    <div className="flex items-center gap-2 text-ink-muted text-xs">
                                        <MessageSquare className="w-4 h-4" />
                                        <span className="font-medium">תגובה {idx + 1}</span>
                                    </div>
                                </div>
                                <p className="leading-relaxed whitespace-pre-wrap font-medium text-ink">{rev.review}</p>
                            </div>
                        ))}
                    </div>
                )}

                <div className="border-t border-line-subtle pt-4">
                    {isGuest ? (
                        <div className="bg-surface-muted border border-line-subtle rounded-lg p-4 text-right space-y-3">
                            <h4 className="text-sm font-semibold text-ink">הוספת תגובה</h4>
                            <p className="text-sm text-ink-muted">שירות זה זמין רק למשתמשים מחוברים.</p>
                            <Button variant="subtle" fullWidth onClick={onClose}>סגור</Button>
                        </div>
                    ) : (
                        <div className="text-right space-y-2">
                            <h4 className="text-sm font-semibold text-ink">הוסיפו תגובה</h4>
                            <Textarea
                                value={newComment}
                                onChange={(e) => onChangeComment(e.target.value)}
                                rows={3}
                                placeholder="כתבו תגובה..."
                            />
                            <Button
                                variant="primary"
                                fullWidth
                                onClick={onSubmitComment}
                                loading={posting}
                            >
                                הוסף תגובה
                            </Button>
                        </div>
                    )}
                </div>
            </div>
        </Modal>
    );
}

export default BusinessReviewsModal;
